import { defineMessages } from 'react-intl';

export default defineMessages({
  no_preview: {
    id: 'kustomer.chat.history.item.preview',
    description: 'Copy for no preview state',
    defaultMessage: 'No preview available',
  },
  closed: {
    id: 'kustomer.chat.history.item.closed',
    description: 'Copy for no closed state',
    defaultMessage: 'Closed',
  },
});
